export default "__VITE_ASSET__C9Dh$t3t__"